"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_LIBRARY = exports.MIN_NUM_MEASURES = exports.REMOTE_STORAGE = exports.LOCAL_STORAGE = exports.DEFAULT_CHORD_LENGTH = exports.DEFAULT_CHORD = exports.DEFAULT_PATTERN_LENGTH = exports.DEFAULT_PATTERN = exports.BlockMode = exports.Triggers = exports.baseAssetUrl = void 0;
exports.baseAssetUrl = 'https://curriculum.code.org/media/musiclab/';
exports.Triggers = [
    {
        id: 'trigger1',
        dropdownLabel: '1',
        buttonLabel: '1',
        keyboardKey: '1',
    },
    {
        id: 'trigger2',
        dropdownLabel: '2',
        buttonLabel: '2',
        keyboardKey: '2',
    },
    {
        id: 'trigger3',
        dropdownLabel: '3',
        buttonLabel: '3',
        keyboardKey: '3',
    },
    {
        id: 'trigger4',
        dropdownLabel: '4',
        buttonLabel: '4',
        keyboardKey: '4',
    },
];
exports.BlockMode = {
    ADVANCED: 'Advanced',
    SIMPLE: 'Simple',
    SIMPLE2: 'Simple2',
    TRACKS: 'Tracks',
};
// For reference, events look like this:
// events: [{src: 'sound_1', tick: 3}]
exports.DEFAULT_PATTERN = {
    kit: 'glitch',
    events: [],
};
exports.DEFAULT_PATTERN_LENGTH = 1;
// Type: ChordEventValue
exports.DEFAULT_CHORD = {
    instrument: 'piano',
    notes: [],
    playStyle: 'arpeggio-up',
};
exports.DEFAULT_CHORD_LENGTH = 1;
exports.LOCAL_STORAGE = 'local';
exports.REMOTE_STORAGE = 'remote';
// Minimum number of measures in a song
exports.MIN_NUM_MEASURES = 30;
exports.DEFAULT_LIBRARY = 'default';
